import { makeAutoObservable, runInAction } from "mobx"
import { FIRESTORE_COLLECTIONS } from "../enums"
import { Questionnaire } from "../interfaces"
import Firestore from "../services/FirestoreService"

export class QuestionnaireStore {
	public isLoading = false
	public error: Error | null = null
	public questionnaire: Questionnaire | null = null

	constructor() {
		makeAutoObservable(this)
	}

	public async load(): Promise<void> {
		this.isLoading = true
		this.error = null
		this.questionnaire = null

		let questionnaires: Questionnaire[] | null = null
		let error: Error | null = null

		try {
			questionnaires = await Firestore.query<Questionnaire>(FIRESTORE_COLLECTIONS.QUESTIONNAIRES_COLLECTION)
		} catch (err) {
			error = err as Error
		}

		runInAction(() => {
			this.questionnaire = questionnaires?.find((q) => q.startDate && q.endDate >= new Date().toISOString()) ?? null
			this.error = error
			this.isLoading = false
		})
	}
}
